<template>
	<div id="Login">
		<!-- <router-view></router-view> -->
		<div class="container">
			<!-- <div class="loginContainer">
				<img src="https://new-shengxue985-test.oss-cn-hangzhou.aliyuncs.com/sxzx/2021/3/pic/2a3c50f1382f4e958b7785df8ca47599.png"
					alt="" />
				<div class="right">
					<div class="iptContainer">
						<div class="title">
							登录
						</div>
						<el-input v-model="account" placeholder="请输入账号" prefix-icon="el-icon-user"></el-input>
						<el-input v-model="password" placeholder="请输入密码" prefix-icon="el-icon-lock"
							style="margin-bottom: 50px;"></el-input>
						<div class="btn" @click="login">
							登录
						</div>
					</div>
				</div>
			</div> -->
			<!-- 739px 800px -->
			<div class="left" :style="'background-size:'+833*ratio+'px '+900*ratio+'px'+';'">
			    <!-- <img src="../img/loginLeft.png" alt="" /> -->
			    <div class="guide-unit-wrapper">
			        <div class="guide-unit" :style="'transform: scale('+ratio+');'">
			            <div class="guide-title flex-h">
			                <img style="width:26px;height: 26px;" src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/10/10/duidui11.png" />
			                <span class="flex1" style="color:#000">千校万企联合促就业活动</span>
			            </div>
			            <div class="guide-content">
			                <div class="guide-item">
			                    <span class="guide-label" style="font-weight: 600;color:#000">牵头高校：</span><span class="guide-text">武汉大学、南京大学、哈尔滨工业大学、西安交通大学、北京航空航天大学、中山大学、吉林大学、大连理工大学、东北大学、南开大学、天津大学、山东大学、厦门大学、兰州大学、华南理工大学、湖南大学、郑州大学、合肥工业大学、河北工业大学、太原理工大学、南昌大学、云南大学、贵州大学、内蒙古大学、海南大学等。</span>
			                </div>
			                <div class="guide-item">
			                    <span class="guide-label" style="font-weight: 600;color:#000">支撑平台：</span> <span class="guide-text">干校万企云平台</span>
			                </div>
			            </div>
			        </div>
			    </div>
			</div>
			<div class="right">
				<div class="loginContainer1" :style="'transform: scale('+ratio+');'">
					<!-- <div class="switchover">
						<div class="" @click="changeLoginWay">切换为{{ isQrcode ? '账号密码' : '微信扫码' }}登陆</div>
						<img src="../img/qrCode.png" alt="" @click="changeLoginWay" />
					</div> -->
					<div class="logoContainer" style="transform: translateY(15px);">
                        <img style="transform: scale(0.9)"  src="https://oss.sx985.com/2025/10/10/left1012x.png"
                            alt="" />
                    
                    </div>
					<div class="loginType">
						<div class="item">
							<div class="item1" :style="!isQrcode ? 'font-weight: bold;' : ''" @click="chnageType1">账号登录
							</div>
							<div class="xian1" v-if="!isQrcode"></div>
						</div>
						<div class="item">
							<div class="item1" :style="isQrcode ? 'font-weight: bold;' : ''" @click="chnageType2">
								扫码登录/注册</div>
							<div class="xian1" v-if="isQrcode"></div>
						</div>
					</div>
					<template v-if="isQrcode">
						<div class="qrcodeContainer">
							<div class="qrcode">
								<div class="qrcodeImg">
									
									<div class="qrcode1" v-if="qrcodeImg">
										<img class="qrcode1" :src="qrcodeImg" alt="" />
									</div>
									<img class="qrcodeLogo" src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/06/02/logopt.png" alt="" />
									
									<div class="refresh" v-if="count > 120" @click="refreshQrcode()">
										<i class="el-icon-refresh-left"></i>
										<div class="" style="font-family: PingFang SC;">点击刷新</div>
									</div>
									
									<div class="scanSuccessful" v-if="isScanSuccessful&&count <= 120">
											<img src="../img/scanSuccessful.png"/>
										<div class="">
											扫码成功
										</div>
									</div>
								</div>
								<template v-if="isScanSuccessful&&count <= 120">
									<div class="hite2" style="margin-bottom: 10px;font-weight: 600;">请在手机上授权登录平台</span>
									</div>
									<div class="hite2" style="font-family: PingFang SC;color: #0084ff;cursor: pointer;" @click="reload">
										重新扫码
										</div>
								</template>
								<template v-else>
									<div class="hite1">打开<span style="color: #0084ff;font-family: PingFang SC;">微信扫一扫</span>
									</div>
									<div class="hite2" style="font-family: PingFang SC;">
										{{ isForget == 0 ? '快速登录/注册' : '找回密码' }}</div>
								</template>
								
							</div>
						</div>
					</template>

					<template v-else>
						<div class="iptContainer">
							<div class="ipt" style="margin-bottom: 25px">
								<img src="../img/account.png" alt="" />
								<el-input v-model="account" style="font-family: PingFang SC;" onpaste="return false"
									autocomplete="off" placeholder="请输入您的手机号" @input="phone"></el-input>
							</div>
							<div class="ipt">
								<img src="../img/password.png" alt="" />
								<el-input v-model="password" style="font-family: PingFang SC;" onpaste="return false"
									autocomplete="off" placeholder="请输入您的密码" show-password></el-input>
							</div>
						</div>

						<div class="" style="display: flex; width: 100%; margin-bottom: 10px; align-items: center">
							<img src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/04/23/ebod4gyjzy7aiads.png"
								style="width: 15px; height: 15px; margin-right: 5px"
								:style="hint ? 'opacity: 1;' : 'opacity: 0;'" alt="" />
							<div class="register" style="color: red; cursor: initial; font-size: 14px"
								:style="hint ? 'opacity: 1;' : 'opacity: 0;'">{{ loginMsg }}</div>
						</div>

						<div class="moreOpt">
							<div class="forgetPassword" style="font-family: PingFang SC;" @click="toforgetPassword">忘记密码
							</div>
							<div class="register" style="font-family: PingFang SC;" @click="chnageType2">没有账号？点击注册</div>
						</div>

						<div class="btn" @click="loginHr" :loading="true" style="font-family: PingFang SC;">登录</div>

						<div class="agreement" style="margin-bottom: 61px">
							<el-checkbox v-model="checked" style="margin-right: 5px"
								@click="selectAgreement"></el-checkbox>
							<span style="font-family: PingFang SC;" @click="selectAgreement">已阅读并同意</span>
							<!-- <span style="color: #0084ff" @click="">《用户协议》</span> -->
							<span style="color: #0084ff" @click="toAgreement">《隐私协议》</span>
						</div>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		mapMutations,
		mapActions
	} from 'vuex'
	import CryptoJS from '../assets/crypot-js.min.js'
	import cryptokey from '../assets/cryptokey.js'
	const config = require('../../WebConfig')
	// import { getMeetList, getQrcode, loginByScene } from '@/api/studentv2.js'
	export default {
		data() {
			return {
				qrcodeImg: '',
				account: '',
				password: '',
				sceneId: '',
				checked: false,

				isQrcode: false,
				intervalId: null,
				isForget: 0,

				count: 0,

				loginMsg: '请输入手机号',

				hint: false,


				ratio: 0,

				channel: null,
				isScanSuccessful:false,
				request:false,
				ismeet:0,
			}
		},
		// destroyed() {
		// 	clearInterval(this.intervalId)
		//
		// },
		mounted() {
			clearInterval(this.intervalId)
			window.removeEventListener('resize', this.handleResize)
			this.handleResize()
			window.addEventListener('resize', this.handleResize);
			
			this.ismeet  = sessionStorage.getItem('ismeet')
			if (this.$route.query.id) {
				this.channel = this.$route.query.id
				localStorage.setItem('salesmanPhone', this.$route.query.id)
			}

			// this.$util.post(
			// 	"/login/login", {
			// 		username: this.ruleForm.username,
			// 		password: this.$md5(this.ruleForm.pass),
			// 	},
			// 	(res) => {
			//
			// 		if (res.code == 1) {
			// 			localStorage.setItem("token", res.data.token);
			// 			this.$router.push({
			// 				path: "/main",
			// 				// query: {
			// 				//   id: 1,
			// 				// },
			// 			});
			// 		}
			// 	}
			// );
			// this.getMeetList()
			this.qrcodeImg = localStorage.getItem('qrcodeImg') || ''

			setTimeout(async() => {
				await this.getQrcode()
			}, 1000)
			// this.loginByScene()
		},

		beforeDestory() {
			clearInterval(this.intervalId)
		},
		methods: {
			...mapActions(['getCompanyUserInfo']),
			...mapMutations(['setToken', 'setUserInfo', 'setSchoolData', 'setUserId', 'setAdminId']),
			async reload(){
				if (this.isRequest()) return false
				this.count = 0
				clearInterval(this.intervalId)
				await this.getQrcode()
				this.isScanSuccessful = false
				this.setTimer()
			},
			updateUserStatus(admin_id){
				this.$util.post(
					"job/im/updateUserStatus", {
						userId:admin_id,
						platform:3,
						userType:1,
						onlineStatus:1,
					},
					(res) => {
						
					}
				);
			},
			handleResize() {
				console.log(window.innerHeight)
				if (window.innerHeight > 600) {
					this.ratio = parseFloat(window.innerHeight / 919)
				} else {
					this.ratio = 0.65
				}
			},
			toAgreement() {
				// this.$router.push({
				// 	path: '/privacy',
				// 	// query: {
				// 	//   id: 1,
				// 	// },
				// })
				window.open('https://xz-platform.sx985.com/privacy', '_blank')
			},
			login() {
				this.setIslogin(true)
				this.$router.push({
					path: '/',
					// query: {
					//   id: 1,
					// },
				})
			},
			phone() {
				this.account = this.account.replace(/\D/g, '')
			},
			// 防抖处理
			isRequest(duration = 1000) {
				if (this.request) return true
				this.request = true
				setTimeout(() => {
					this.request = false
				}, duration)
				return false
			},
			decrypt(data) {
				
				// 1. 将Base64字符串转换为CryptoJS可处理的格式
				const encrypted = CryptoJS.enc.Base64.parse(data)
				// 2. 构建解密配置
				const decryptConfig = {
					iv: cryptokey.SECRET_IV,
					mode: CryptoJS.mode.CBC,
					padding: CryptoJS.pad.Pkcs7, // AES默认填充方式
				}
				// 3. 执行解密
				const decrypted = CryptoJS.AES.decrypt({
						ciphertext: encrypted,
					}, // 传入加密数据
					cryptokey.SECRET_KEY,
					decryptConfig
				)
				// 4. 将解密结果转换为UTF-8字符串
				return decrypted.toString(CryptoJS.enc.Utf8)
			},
			async refreshQrcode() {
				if (this.isRequest()) return false
				this.count = 0
				await this.getQrcode()
				this.isScanSuccessful = false
				this.setTimer()
			},
			loginHr() {
				if (this.isRequest()) return false
				clearInterval(this.intervalId)
				if (!this.account) {
					// this.$message.error('请输入手机号码')

					this.hint = true
					this.loginMsg = '请输入手机号码'
					setTimeout(() => {
						this.hint = false
					}, 2000)

					return
				}
				if (!this.password) {
					// this.$message.error('请输入账号密码')

					this.hint = true
					this.loginMsg = '请输入密码'
					setTimeout(() => {
						this.hint = false
					}, 2000)

					return
				}
				if (!this.checked) {
					// this.$message.error('请认真阅读并同意隐私协议')

					this.hint = true
					this.loginMsg = '请阅读并同意隐私协议'
					setTimeout(() => {
						this.hint = false
					}, 2000)

					return
				}
				let obj = {
					tel: this.account,
					password: this.password,
				}

				this.$util.post(
					'v2/school_job/login_hr', {
						...obj,
					},
					(resx) => {
						if (resx.code == -1) {
							// this.isQrcode = true

							if (resx.msg == '账号不存在') {
								// this.$message.error(res.msg+'请先注册')
								this.hint = true
								this.loginMsg = '账号不存在请先注册'

								setTimeout(() => {
									// this.isQrcode = true
									this.hint = false
								}, 2000)
							} else {
								// this.$message.error(res.msg)
								this.hint = true
								this.loginMsg = resx.msg
								setTimeout(() => {
									this.hint = false
								}, 2000)
							}
							return
							// this.setTimer()
						}

						if (resx.code) {
							this.$message.error(resx.msg)
							// this.setTimer()

							this.hint = true
							this.loginMsg = resx.msg
							setTimeout(() => {
								this.hint = false
							}, 2000)

							return
						}

						// resx.toString()
						// let resp = this.decrypt(resx)
						let str1 = resx
						// let str = `byvkPsyIfFJG9+LI9XhaGoGUDcsbEkf6YlpWuLZc+N/mIINDdrWYrjJJJpZ/CuzdJSMikUz1Doxe2gYaZNk9C0dgfMFDkWeupRCJz3lF8Qfq1rXuEJTJyYdqElsyQq1XCMqVpyqWDHbcTMznEsPogmWe0KVE7Z6ej7x7/C9adxmK6xQMfD+fX6W6Wg3cbd7wg5kqU4kiLZrim8vIHZvrxvonVj+LgVWdEf4ju70ZTAeiNMzPCzedopgd45Ta8A+iaAlfVKDfbEbP0fLTsagpep5QoLpr8brbnRtRtJOyAY8vdUrkg6nE/y/kmREUFI2xHKokbmjS7MpfJRJ7NFdppyICiymesgUuIWKXQpmKRP1yEVxtrN2+baPfAaRIdQq3jAUozghOJTJTc63JZTEHQjhj6t9t3A1bKyk3/3k+2mzXOtz6FLMm3mG3j5LvwjiotCATyQpRube1EMR+1Jt9zMALq/aW3d89UKhqhgv+Yslf+/xTqH9QkBuH1zkjX+XnLKs1Y9NeHKJQgFEUxn0Lnaf6u3IM5zF0hRvw37OMRy0umHfg+5bnmAA7MWi9JYzjpvMog+qQP1OCmZjPp36/wcJf9GIbBzow7iMsSYflRoFcgfArRG/7Ki47Qa0yFDuVuKns5eb7cfJGh/GPaGMJLpc7jRbhoi1SPvG22/RqMaNRL0qDEy4rGdXBdteyztEbxd7WQM1v8l6tGXzjbt+FutClXaSmo5w+OjTA4cGR2kUs4T/FTFxfLTGTUcB9yXkKauNrqfdZ4eYfew8EwJxWyLCcq2ym09teO8Mj3Rz78T44WqUfdDoilGIpQKjGMjUcOz+WvvBZeBw8Drib5xidrEJxpnb8uhus8k6A4+jZv3WMrVnSrwkVzuM1KpE8BnXKDTo7J9mEBY3UBAAEuDgbkcM+0JmTqTFzTraKlxf30zu3FcUd8w+U0kzKrVYqVkU1JaQj80w0ZhtJ+U3j9/4qj2B5WGCGVDk984C3bblaDuDUNF/bG04+MEKBQey3NczOq/KNurTb4CryWT9dBNyincoScPjuY4nDL87OedYlO91XZavydwCaoMfHi3B4lRFt1LWGuNyLStoS97RWs9GFEBzrk/aWqZncB/0X+r4kIAyIAGm3utQ34JfbDsktAuKtEU2AVCDYplS8bKF1Tc4WnTIIPXBMEpnyJTfJxVhnjUqqZ9a3cFBHi65ywc09WApgKw5bn0DBcvbn5Fzvcy2y6OJTUPZvYXaar3O9hPwq8Vj8SXSfP6HdJHBAr79/4dPYp0C1JCi0cl43wF+2Al7DxA==`
						
						let resp = this.decrypt(resx.data)
						let res = JSON.parse(resp)
						console.log(res)

						if (res.code === 200) {
							// this.$message({
							// 	message: '登录成功',
							// 	type: 'success',
							// 	duration: 1000
							// });
							// this.$message.success("登录成功")

							if (res.data.status === 0) {
								this.$alert('抱歉，您的账号已被贵司超级管理员注销，请联系管理员开启账号权限！', '标题', {
									confirmButtonText: '确定',
									callback: () => {},
								})
							} else {
								this.getCompanyInfo(res.data.admin_id)
								this.setUserInfo(res.data)
								this.setUserId(res.data.user_id)
								this.setAdminId(res.data.admin_id)
								this.setToken(res.data.new_token)
								
								if(this.ismeet){
									setTimeout(() => {
										let is_demo = sessionStorage.getItem('demo')
										if(is_demo){
											this.$router.push({
												path: '/meeting?demo='+is_demo,
											})
										}else{
											this.$router.push({
												path: '/meeting',
											})
										}
									}, 1000)
								}else{
									
									setTimeout(() => {
										if(window.previousPath&&window.previousPath!='/'&&window.previousPath!='/forgetPassword'&&window.previousPath!='/register'&&window.previousPath!='/accountManagement'){
											this.$router.go(-1)
										}else{
											this.$router.push({
												path: '/home',
											})
										}
									}, 1000)
								}
								
							}
						}
					}
				)

				// loginHr(obj).then((res) => {
				//
				// 	if (res.code === 200) {
				// 		this.$message.success("登录成功")

				// 		this.getCompanyInfo(res.data.admin_id)
				// 		setTimeout(() => {
				// 			this.$router.push({
				// 				path: '/home',
				// 			})
				// 		}, 200)
				// 	} else {
				// 		this.$message.error(res.msg)
				// 	}

				// })
			},
			setTimer() {
				this.intervalId = setInterval(() => {
					if(this.isScanSuccessful){
						this.loginByScene()
					}else{
						this.loginByScene2()
					}
					if (this.count > 120) {
						clearInterval(this.intervalId)
					} else {
						this.count += 2
					}
				}, 2000)
			},
			getCompanyInfo(adminId) {
				if (!adminId) {
					return
				}
				this.$util.post(
					'v2/school_job/getCompanyInfo', {
						admin_id: adminId,
					},
					(res) => {
						if (res.code === 200) {
							if (res.data.job_title && res.data.job_title[0]) {
								// localStorage.setItem('job_title', JSON.stringify(res.data.job_title))
								// this.jobs = {
								// 	job_title: JSON.stringify(res.data.job_title),
								// }
							} else {
								localStorage.setItem('job_title', '')
							}
							// this.$store.commit('setSchoolData', res.data)
							this.setSchoolData(res.data)
							// localStorage.setItem('schoolData', JSON.stringify(res.data))
						}
						this.updateUserStatus(adminId)
					}
				)
				//   getCompanyInfo(adminId).then((res) => {
				//     if (res.code === 200) {
				//       if (res.data.job_title && res.data.job_title[0]) {
				//         localStorage.setItem('job_title', JSON.stringify(res.data.job_title))
				//         this.jobs = {
				//           job_title: JSON.stringify(res.data.job_title),
				//         }
				//       } else {
				//         localStorage.setItem('job_title', '')
				//       }

				//       this.$store.commit('setSchoolData', res.data)
				//       localStorage.setItem('schoolData', JSON.stringify(res.data))
				//     }
				//   })
			},
			loginByScene2(){
				this.$util.post(
					'api/student/login_by_scene2', {
						scene: this.sceneId,
						not_login:1
					},
					(resx) => {
						if(resx.code==0){
							if(resx.data.register == 2){
								this.isScanSuccessful = true
							}
						}
					}
				)
			},
			loginByScene() {
				if (!this.sceneId) {
					clearInterval(this.intervalId)
					return
				}
				this.$util.post(
					'api/student/login_by_scene', {
						scene: this.sceneId,
						// scene: this.sceneId,
					},
					(responce) => {
						if (responce.data) {
							// this.$message({
							// 	message: '登录成功',
							// 	type: 'success',
							// 	duration: 1000
							// });
								clearInterval(this.intervalId)
								this.setToken(responce.data.new_token)
								// localStorage.setItem('nextToken', responce.data.new_token)
								// this.$store.commit('SET_NEWTOKEN', responce.data.new_token)
								// localStorage.setItem('user_id', JSON.stringify(responce.data.id))
								this.setUserId(responce.data.user_info.id)
								this.setUserInfo(responce.data.user_info)
								
								// this.$store.commit('setUserinfo', responce.data.user_info)
								if (responce.data.register === 0) {
									setTimeout(() => {
										this.$router.push({
											path: '/register',
										})
									}, 1000)
								}
								if (responce.data.register === 1) {
									this.$util.post(
										'v2/school_job/getCompanyUserInfo', {
											// admin_id: 0,
											user_id: responce.data.user_info.id,
										},
										(res) => {
											if (res.code === 0) {
												if (res.data) {
													// localStorage.getItem('hrInfo', res.data)
													if (res.data.status === 0) {
														this.$alert('抱歉，您的账号已被贵司超级管理员注销，请联系管理员开启账号权限！', '标题', {
															confirmButtonText: '确定',
															callback: () => {},
														})
													} else {
														if (res.data.admin_id) {
															
															// localStorage.getItem('admin_id', res.data.admin_id)
															// this.$store.commit('setAdminId', res.data.admin_id)
															// localStorage.setItem('userinfo', JSON.stringify(res.data))
															this.getCompanyUserInfo()
															// localStorage.getItem('account', res.data.admin_id)
															this.setAdminId(res.data.admin_id)
															this.getCompanyInfo(res.data.admin_id)
															
															
															if(this.ismeet){
																setTimeout(() => {
																	let is_demo = sessionStorage.getItem('demo')
																	if(is_demo){
																		this.$router.push({
																			path: '/meeting?demo='+is_demo,
																		})
																	}else{
																		this.$router.push({
																			path: '/meeting',
																		})
																	}
																}, 1000)
															}else{
																console.log(window.previousPath)
																setTimeout(() => {
																	if(window.previousPath&&window.previousPath!='/'&&window.previousPath!='/forgetPassword'&&window.previousPath!='/register'&&window.previousPath!='/accountManagement'){
																		this.$router.go(-1)
																	}else{
																		this.$router.push({
																			path: '/home',
																		})
																	}
																}, 1000)
															}
															
														} else {
															setTimeout(() => {
																if (this.channel) {
																	this.$router.push({
																		path: '/register',
																	})
																} else {
																	this.$router.push({
																		path: '/register',
																	})
																}
								
															}, 1000)
								
														}
													}
												} else {
													setTimeout(() => {
														if (this.channel) {
															this.$router.push({
																path: '/register',
															})
														} else {
															this.$router.push({
																path: '/register',
															})
														}
													}, 1000)
												}
											}
											//  else {
											// 	setTimeout(() => {
											// 		this.$router.push({
											// 			path: '/register',
											// 		})
											// 	}, 1000)
											// }
										}
									)
								
									// getCompanyUserInfo(0, responce.data.user_info.id).then((res) => {
									// 	if (res.code === 0) {
									// 		if (res.data) {
									// 			// localStorage.getItem('hrInfo', res.data)
									// 			if (res.data.admin_id) {
									// 				localStorage.getItem('admin_id', res.data.admin_id)
									// 				this.$store.commit('setAdminId', res.data.admin_id)
									// 				localStorage.getItem('account', res.data.admin_id)
									// 				this.getCompanyInfo(res.data.admin_id)
									// 				this.$router.push({
									// 					path: '/home',
									// 				})
									// 			} else {
									// 				this.$router.push({
									// 					path: '/register',
									// 				})
									// 			}
									// 		} else {
									// 			this.$router.push({
									// 				path: '/register',
									// 			})
									// 		}
									// 	} else {
									// 		this.$router.push({
									// 			path: '/register',
									// 		})
									// 	}
									// })
								}
								
								
								
								clearInterval(this.intervalId)
						}
					}
				)
				// loginByScene(this.sceneId).then((responce) => {

				// })
			},
			getQrcode() {
				return new Promise((resolve, reject) => {
				this.$util.post(
					'admin/home/qrcode', {
						app_type: 10,
						page_path: 'pages/login/login',
						is_test:0
					},
					(res) => {
						if (res.code == 200) {
							this.qrcodeImg = res.data.qrCode
							this.sceneId = res.data.scene
							// this.setTimer()
							localStorage.setItem('qrcodeImg', res.data.qrCode)
							resolve()
						}else{
							resolve()
						}
					}
				)
				})
			},
			// getQrcode().then((res) => {
			// 	if (res.code == 200) {
			// 		this.qrcodeImg = res.data.qrCode
			// 		this.sceneId = res.data.scene

			// 		this.setTimer()
			// 		localStorage.setItem('qrcodeImg', res.data.qrCode)
			// 	}
			// })
			// getMeetList(){
			//       	let obj = {
			//       		page:1,
			//       	}
			//         //   if(this.headIndex){
			//         //       obj.meeting_type =this.headIndex
			//         //   }
			//       	// if(this.tapIndex!=0){
			//       	// 		obj.meeting_status = this.tapIndex
			//       	// }
			//       	getMeetList(obj).then(res => {
			//       	    if (res.code === 200) {

			//       	    }
			//       	})
			//       },
			toforgetPassword() {
				this.$router.push({
					path: '/forgetPassword',
				})
			},
			toRegister() {
				if (this.isRequest()) return false
				this.isQrcode = true
				this.qrcodeTxt = '注册'
				this.isForget = 1
				this.setTimer()
				// this.setTimer()
			},
			changeLoginWay() {
				// clearInterval(this.intervalId)
				this.isQrcode = !this.isQrcode
				this.qrcodeTxt = '登录/注册'
				this.isForget = 0
				// if (!this.isQrcode) {
				// 	clearInterval(this.intervalId)
				// } else {
				// 	this.setTimer()
				// }
			},
			async chnageType1() {
				if (this.isRequest()) return false
				this.isQrcode = false
				this.count = 0
				clearInterval(this.intervalId)
				await this.getQrcode()
				this.isScanSuccessful = false
				
			},
			chnageType2() {
				if (this.isRequest()) return false
				clearInterval(this.intervalId)
				this.isQrcode = true
				this.count = 0
				this.setTimer()
				// this.qrcodeTxt = '登录/注册'
				this.isForget = 0
			},

			selectAgreement() {
				this.checked = !this.checked
			},
		},
		components: {},
	}
</script>
<style>
	#Login .el-input__inner {
		border: none;
		background: #e0eafe;
		font-size: 18px;
	}

	/* 设置所有input元素的placeholder文本颜色为灰色 */
	#Login input::placeholder {
		color: #656565;
	}

	#Login .el-checkbox__inner {
		/* border-radius: 50%; */
		border: 1px solid #0084ff;
	}
</style>
<style lang="less" scoped>
	#Login {}

	.container {
		width: 100%;
		height: 100vh;
		display: flex;
		align-items: center;
		background: #e0f0ff;
		// justify-content: center;
		// background: url(https://new-shengxue985-test.oss-cn-hangzhou.aliyuncs.com/sxzx/2021/3/pic/16c3b44183f34011a10909b690f1869a.png);
	}

	.left {
	    min-width: 600px;
        width: 50%;
        font-size: 0;
        height: 100vh;
        background: url(https://oss.sx985.com/2025/10/10/left1012.png);
        background-repeat: no-repeat;
        // background-size: 739px 800px;
        background-position:top center;
        position: relative;
        // transform: translateY(-24px);
        transform: scale(0.9);
	
	    .guide-unit-wrapper {
	        position: absolute;
	        left: 50%;
	        bottom: 30px;
	        transform: translateX(-50%);
	        width: 100%;
	        display: flex;
	        justify-content: center;
	    }
	
	    .guide-unit {
	        max-width: 700px;
	        width: 100%;
	        padding: 15px 20px;
	        // background: rgba(255, 255, 255, 0.9);
	        // border: 1px solid #e0e0e0;
	        border-radius: 8px;
	        transform-origin: bottom center;
	        .guide-title {
	            display: flex;
	            align-items: center;
	            font-weight: bold;
	            font-size: 14px;
	            color: #333;
	            margin-bottom: 10px;
	            margin-left: -3px;
	
	            i {
	                color: #1e40af;
	                margin-right: 8px;
	                font-size: 16px;
	            }
	        }
	
	        .guide-content {
	            .guide-item {
	                font-size: 12px;
	                color: #666;
	                line-height: 1.6;
	                margin-bottom: 8px;
	
	                &:last-child {
	                    margin-bottom: 0;
	                }
	            }
	            span{
	                // font-size:14px;
	            }
	            .guide-label {
	                color: #333;
	                font-weight: 500;
	                // display: inline-block;
	                vertical-align: top;
	            }
	
	            .guide-text {
	                // display: inline-block;
	                vertical-align: top;
	                word-break: break-all;
	                color:#000000;
	                opacity: 0.8;
	            }
	        }
	    }
	}

	.right {
		width: 50%;
		min-width: 600px;
		background: #f7faff;
		height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;
		min-height: 600px;
	}

	.loginContainer {
		display: flex;
		font-size: 0;

		// .right {
		// 	width: 600px;
		// 	height: 640px;
		// 	background: #fff;
		// 	border-radius: 0 16rpx 16rpx 0;
		// 	display: flex;
		// 	// align-items: center;
		// 	justify-content: center;
		// 	background: #fff;
		.iptContainer {
			padding-top: 100px;

			.title {
				font-size: 28px;
				font-weight: bold;
				color: #0a2145;
				margin-bottom: 100px;
			}

			.el-input {
				margin-bottom: 25px;
			}

			.btn {
				width: 100%;
				height: 40px;
				line-height: 40px;
				text-align: center;
				font-size: 14px;
				color: #fff;
				background: #0c66ff;
				border-radius: 8px;
			}
		}

		// }
	}

	.loginContainer1 {
		width: 510px;
		display: flex;
		align-items: center;
		flex-direction: column;
		// height: 695px;
		// border-radius: 10px;
		// box-shadow: 0px 4px 57px 8px rgba(0, 0, 0, 0.1);
		box-sizing: border-box;
		padding: 25px 25px;
		background: #f7faff;
        // transform: translateY(-40px);
        // margin-top:-110px;

		.switchover {
			display: flex;
			font-size: 0;
			justify-content: flex-end;

			div {
				height: min-content;
				padding: 5px 18px;
				background: #f5f9ff;
				font-weight: 400;
				font-size: 18px;
				color: #0084ff;
				border-radius: 2px;
				margin-right: 2px;
			}

			img {
				width: 85px;
				height: 85px;
			}
		}

		.logoContainer {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 0;
			margin-bottom: 50px;

			img {
                width:490px;
                height: 50px;
               margin-bottom: 80px;
            }

			// font-size: 40px;
			// font-weight: bold;

		}

		.iptContainer {
			margin-bottom: 10px;

			.ipt {
				width: 460px;
				padding: 10px 15px;
				box-sizing: border-box;
				background: #e0eafe;
				border-radius: 10px;
				display: flex;
				align-items: center;

				img {
					width: 30px;
					height: 30px;
					margin-right: 10px;
				}
			}
		}

		.moreOpt {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin-bottom: 25px;

			.forgetPassword {
				font-weight: 500;
				font-size: 18px;
				color: #0084ff;
				cursor: pointer;
			}

			.register {
				font-weight: 500;
				font-size: 18px;
				color: #3a3a3a;
				cursor: pointer;
			}
		}

		.btn {
			width: 100%;
			height: 56px;
			background: #1e40af;
			border-radius: 10px;
			text-align: center;
			line-height: 56px;

			font-weight: 500;
			font-size: 18px;
			color: #ffffff;
			margin-bottom: 25px;

			cursor: pointer;
		}

		.agreement {
			width: 100%;
			font-weight: 500;
			font-size: 18px;
			color: #999999;
			cursor: pointer;
			margin-bottom: 25px;
		}
	}

	.qrcodeContainer {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;

		.qrcode {
			width: 410px;
			height: 407px;
			background: #ffffff;
			border-radius: 10px;
			// border: 4px solid #0084ff;
			box-shadow: 0px 4px 30px 0px rgba(0, 0, 0, 0.1);
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			font-size: 0;

			.qrcodeImg {
				width: 208px;
				height: 208px;
				margin-bottom: 37px;
				font-size: 0;
				position: relative;

				.qrcode1 {
					width: 208px;
					height: 208px;
					z-index: 10;
				}

				.qrcodeLogo { position: absolute; top: 0; left: 0; right: 0; z-index: 1; width: 90px; height: 90px; border-radius: 50%; margin: 58px auto; }

				.refresh {
					position: absolute;
					left: 0;
					top: 0;
					z-index: 10;
					width: 208px;
					height: 208px;
					background: rgba(0, 0, 0, 0.8);
					border-radius: 10px;
					display: flex;
					align-items: center;
					justify-content: center;
					flex-direction: column;
					cursor: pointer;

					i {
						font-size: 50px;
						color: #fff;
						margin-bottom: 20px;
						margin-top: 25px;
					}

					div {
						font-size: 16px;
						color: #fff;
					}
				}
				.scanSuccessful{
					position: absolute;
					width: 208px;
					height: 208px;
					top: 0;
					left: 0;
					background: rgba(255, 255, 255, 0.96);
					z-index: 11;
					
					display: flex;
					align-items: center;
					justify-content: center;
					flex-direction: column;
					padding-top: 10px;
						img{
							width: 110px;
							height: 110px;
							// margin-bottom: 10px;
						}
					div{
						font-size: 18px;
						color: #353535;
					}
				}
			}

			.hite1 {
				font-weight: bold;
				font-size: 24px;
				color: #333333;
				margin-bottom: 5px;
			}

			.hite2 {
				font-weight: 500;
				font-size: 18px;
				color: #333333;
			}
		}
	}

	.loginType {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-around;
		margin-bottom: 35px;

		.item {
			position: relative;
			cursor: pointer;

			.item1 {
				font-size: 22px;
				font-weight: 500;
				color: #333333;
				font-family: PingFang SC;
				margin-bottom: 10px;
			}

			.active {
				font-weight: bold;
			}

			.xian1 {
				position: absolute;
				width: 40px;
				height: 5px;
				border-radius: 5px;
				background: #1b59fa;
				left: 50%;
				transform: translate(-50%);
			}
		}
	}
</style>
